import { httpClient } from '@/utils/http'
import type { BaseResponse, RoleList } from '@/types/api'

export class CheckCenterAPI {
  static async getSignInList(data: any): Promise<BaseResponse<any>> {
    return httpClient.post<RoleList>('/signList', data)
  }
  /**
   * 用户签到
  */
  static async getUserSignIn(data: any): Promise<BaseResponse<any>> {
    return httpClient.post<any>('/userSignIn', data)
  }
  /**
   * 用户砖石任务
  */
  static async getCurDate(data: any): Promise<BaseResponse<any>> {
    return httpClient.post<any>('/userTask', data)
  }
  /**
   * 用户任务领取
  */
  static async getTaskReward(data: any): Promise<BaseResponse<any>> {
    return httpClient.post<any>('/getTaskReward', data)
  }
  

}

// 默认导出
export default {
  CheckCenterAPI
}
